import apiClient from "./ApiService";
import { PATH_EDUCATIONS } from "../config/env";

export const getEducations = async()=>{
    return await apiClient.get(PATH_EDUCATIONS);
}

export default getEducations;